import { NetworkRequest } from "./NetworkRequest";
import { NetworkService } from "./NetworkService";

export class LogsServices {
  static async postLog(action) {
    return await NetworkService.request({
      alias: NetworkRequest.PostLog,
      url: "users/usagelog",
      method: "POST",
      data: action,
      contentType: "text/plain",
    }).then((response) => {
      return response;
    }).catch((reason) => {
      console.log("Error posting log", reason);
      throw reason;
    })
  }

  static async fetchLogs() {
    return await NetworkService.request({
      alias: NetworkRequest.FetchLogs,
      url: "users/usagelog",
      method: "GET",
    }).then((response) => {
      return response;
    }).catch((reason) => {
      console.log("Error fetching logs", reason);
      throw reason;
    })
  }

}